import ContentWrapper from "../views/components/ContentWrapper";
import { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import React from 'react';
import { getSearchResults } from "../data/dataApi";
import Pagination from "../views/components/Pagination";

const Search = () => {
    const [searchResults, setSearchResults] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();

    const { query, page } = useParams();

    const listLimit = 20;

    useEffect(() => {
        (async () => {
            const response = await getSearchResults(query, listLimit, page - 1 || 0);
                        
            if(response.success) {
                setSearchResults(response.data.rows);
            }
        })();
    }, [query, page]);

    return (
        <ContentWrapper className="search scrollable">
            <div className="back-wrapper">
                <button className="tertiary-btn tif-mb-10"
                    onClick={() => {
                        if (location.key === 'default') {
                        navigate('/history')
                        } else {
                        navigate(-1)
                        }
                    }}>
                    Back
                </button>
            </div>
            <p className="search-query tif-m-0 tif-px-40 tif-pb-30">Search: { decodeURIComponent(query) }</p>
            <div className="wrapper tif-bg-color-alpha tif-bg-light-color-white">
                <div className="table-wrapper">
                    <table className="secondary-table w-100">
                        <thead>
                            <tr>
                                <td>Sender</td>
                                <td>Message</td>
                            </tr>
                        </thead>
                        
                        {searchResults.map((history, index) => (
                            <React.Fragment key={index}>
                                <tbody>
                                    <tr className="spacer-row" key={`${index}-0`}>
                                        <td colSpan="3"></td>
                                    </tr>
                                </tbody>
                                <tbody className="result secondary-body" onClick={() => navigate(`/history/${ history.session_id }`)}>
                                    <tr className="first-row" key={`${index}-1`}>
                                        <td>User</td>
                                        <td>{history.user_message}</td>
                                    </tr>
                                    <tr className="second-row" key={`${index}-2`}>
                                        <td>Chatbot</td>
                                        <td>{history.api_response}</td>
                                    </tr>
                                </tbody>
                            </React.Fragment>
                        ))}
                    </table>

                    <Pagination listLength={ searchResults.length && searchResults[0].total_count } path={`/search/${ query }`} page={ page } limit={ listLimit } />
                </div>
            </div>
        </ContentWrapper>
    );
}

export default Search;